import { LoginForm, User } from '@ui/types';

export const AUTH_ACTIONS = {
  AUTH_RELOADED: 'auth/reloaded',
  LOGIN_REQUESTED: 'login/requested',
  LOGIN_FAILED: 'login/failed',
  LOGIN_SUCCEEDED: 'login/succeeded',
  LOGOUT_REQUESTED: 'logout/requested',
  LOGOUT_FAILED: 'logout/failed',
  LOGOUT_SUCCEEDED: 'logout/succeeded',
};

export interface AuthReloaded {
  type: string;
  payload: { user: User };
}

export const authReloaded = (user: User): AuthReloaded => ({
  type: AUTH_ACTIONS.AUTH_RELOADED,
  payload: { user },
});

export interface LoginRequested {
  type: string;
  payload: LoginForm;
}

export const loginRequested = (
  login: string,
  password: string,
): LoginRequested => ({
  type: AUTH_ACTIONS.LOGIN_REQUESTED,
  payload: { login, password },
});

export interface LoginFailed {
  type: string;
  error: string;
}

export const loginFailed = (error: string): LoginFailed => ({
  error,
  type: AUTH_ACTIONS.LOGIN_FAILED,
});

export interface LoginSucceeded {
  type: string;
  payload: { user: User };
}

export const loginSucceeded = (user: User): LoginSucceeded => ({
  type: AUTH_ACTIONS.LOGIN_SUCCEEDED,
  payload: { user },
});

export interface LogoutRequested {
  type: string;
}

export const logoutRequested = (): LogoutRequested => ({
  type: AUTH_ACTIONS.LOGOUT_REQUESTED,
});

export interface LogoutSucceeded {
  type: string;
}

export const logoutSucceeded = (): LogoutSucceeded => ({
  type: AUTH_ACTIONS.LOGOUT_SUCCEEDED,
});

export interface LogoutFailed {
  type: string;
  error: string;
}

export const logoutFailed = (error: string): LogoutFailed => ({
  error,
  type: AUTH_ACTIONS.LOGOUT_FAILED,
});

export type AuthAction =
  | AuthReloaded
  | LoginRequested
  | LoginFailed
  | LoginSucceeded
  | LogoutRequested
  | LogoutSucceeded
  | LogoutFailed;



// WEBPACK FOOTER //
// ./src/store/auth/actions.ts